import { gsap } from "animations/gsap";
import CustomEase from "gsap/CustomEase";
import { TickerHookInt } from "interfaces";

// https://codepen.io/rhernando/pen/jzdbMB
// https://greensock.com/forums/topic/23530-some-issues-with-gsap-3-and-3d-transforms-on-the-z-axis/

function numberTicker({
  el,
  target,
  revolutions = 4,
  duration = 2,
}: TickerHookInt) {
  const tickerContainer = document.getElementById(el),
    numDigits = tickerContainer!.childElementCount,
    customEase =
      "M0,0 C0.29,0 0.385,0.037 0.456,0.122 0.525,0.205 0.559,0.379 0.591,0.519 0.611,0.609 0.643,0.789 0.706,0.883 0.781,0.994 0.828,1 1,1 ";

  // constants
  const circleDegrees = 360,
    digitBase = 10,
    degreeIncrement = circleDegrees / digitBase,
    radius = tickerContainer?.getBoundingClientRect().height,
    angle = circleDegrees / digitBase,
    origin = `50% 50% -${radius}px`,
    rotationTargetBase = revolutions * circleDegrees;

  const tickerTL = gsap.timeline({ paused: true });
  tickerTL.current && tickerTL.current.progress(0).kill();

  for (let i = 0; i < numDigits; i++) {
    let digits = tickerContainer!.children[i].children[0];
    let lastDigitNode = digits!.querySelector(
      ".anim-ticker-digit:last-of-type"
    );

    if (digits.childElementCount >= digitBase) {
      gsap.killTweensOf(digits);
      gsap.utils
        .toArray(".anim-ticker-digit", digits)
        .forEach(function (digit: any) {
          gsap.killTweensOf(digit);
        });
    }
    for (let j = 0; j < digitBase; j++) {
      let digitJ = lastDigitNode;
      if (digits.childElementCount >= digitBase) {
        digitJ = digits.children[j];
      } else if (j > 0) {
        digitJ = lastDigitNode!.cloneNode(true) as HTMLElement;
        let lastIntegerPlusJ = parseInt(digitJ!.innerHTML) + j;
        if (lastIntegerPlusJ >= digitBase) {
          lastIntegerPlusJ -= digitBase;
        }
        digitJ!.innerHTML = lastIntegerPlusJ.toString();
        digits!.appendChild(digitJ);
      }
    }
    const rotationTarget = rotationTargetBase + degreeIncrement * target[i];

    gsap.set(digits!.querySelectorAll(".anim-ticker-digit"), {
      z: radius,
      rotationX: (index) => angle * index,
      transformOrigin: origin,
    });
    tickerTL.to(
      digits,
      {
        rotationX: -rotationTarget,
        duration: duration,
        ease: CustomEase.create("custom", customEase),
        transformOrigin: "50% 50%",
        delay: i * 0.05 + 0.2,
      },
      "<"
    );
  }

  return tickerTL;
}

export default numberTicker;
